import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/JsonRenderComponents/signalCards/AssetRsiGaugeCard";
/**
 * ③ RSI 仪表卡。 Figma：94103:23212
 */

import { cn } from "utils";
import { RsiGaugeBar } from "./miniCharts/RsiGaugeBar";
import { SignalCardShell } from "./SignalCardShell";
import type { RsiStatusTone, SignalCardAssetProps } from "./types";

const I18n = I18nUtil.createScoped(Translations);

export interface AssetRsiGaugeCardProps extends SignalCardAssetProps {
  rsiValue: number;
  /** Optional marker position (0–100); defaults to `rsiValue` */
  indicatorPosition?: number;
  statusTone?: RsiStatusTone;
}

const STATUS_LABEL: Record<RsiStatusTone, string> = {
  overbought: "overbought",
  oversold: "oversold",
  neutral: "neutral",
};

const resolveStatusTone = (
  rsiValue: number,
  statusTone?: RsiStatusTone,
): RsiStatusTone => {
  if (statusTone) {
    return statusTone;
  }
  if (rsiValue >= 70) {
    return "overbought";
  }
  if (rsiValue <= 30) {
    return "oversold";
  }
  return "neutral";
};

export const AssetRsiGaugeCard: React.FC<AssetRsiGaugeCardProps> = ({
  rsiValue,
  indicatorPosition,
  statusTone,
  ...asset
}) => {
  const tone = resolveStatusTone(rsiValue, statusTone);
  const toneClass =
    tone === "overbought"
      ? "text-content_accent2_primary"
      : tone === "oversold"
        ? "text-content_accent1_primary"
        : "text-content_primary";

  return (
    <SignalCardShell {...asset}>
      <div className="flex items-center justify-between gap-3">
        <div className={cn("flex flex-col gap-1", toneClass)}>
          <p className="headline_regular_l">
            {I18n.t("RSI")}
            {rsiValue}
          </p>
          <p className="body_medium_m">{STATUS_LABEL[tone]}</p>
        </div>
        <RsiGaugeBar
          rsiValue={rsiValue}
          indicatorPosition={indicatorPosition}
        />
      </div>
    </SignalCardShell>
  );
};
